export default __webpack_public_path__ + "static/media/google-logo.2547fe40.svg";